class EventBroker {

    logService;

    constructor(logService) {
        this.logService = logService;
    }

    subscribe(eventName, callback) {
        this.#subscriptions[eventName] = this.#subscriptions[eventName] == undefined ? [] : this.#subscriptions[eventName];
        this.#subscriptions[eventName].push({ callback: callback });
    }

    subscribeOnce(eventName, callback, uniqueId) {
        this.#subscriptions[eventName] = this.#subscriptions[eventName] == undefined ? [] : this.#subscriptions[eventName];

        for (var i in this.#subscriptions[eventName]) {
            if (this.#subscriptions[eventName][i].uniqueId == uniqueId)
                delete this.#subscriptions[eventName][i];
        }

        this.#subscriptions[eventName].push({ callback: callback, uniqueId: uniqueId });
    }

    fire(eventName, param) {
        //this.logService.info(eventName, param);

        if (this.#subscriptions[eventName]) {
            for (var callbackIndex in this.#subscriptions[eventName]) {
                this.#subscriptions[eventName][callbackIndex].callback(param);
            }
        }
    }

    fireValueChanged(id, output, value) {
        this.fire("valueChangedEvent", {
            id: id,
            key: id + ":" + output,
            value: value
        });
    }

    clear() {
        this.#subscriptions = {};
    }

    #subscriptions = {};
}

export { EventBroker }
